import React from 'react';
import './blog-post.css';
import GHCTapia22Graphic from './pictures/GHCTapia22Graphic.png';


//import reportWebVitals from './reportWebVitals';

const GHCTapia22Recap = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Grace Hopper & Tapia Conference Reflection Event Recap</h2>
                    <p class="site-post-meta">November 2, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On October 26th, we held our annual Grace Hopper and Tapia Conference Reflection!
                        We started off by going over the theme and keynote speakers from each
                        conference. We then started our discussion and talked about how to create
                        safe and welcoming spaces within academia and industry for people of diverse
                        backgrounds. Members also chatted about favorite events and their biggest
                        takeaways at the conferences.
                    </p>
                    <p>
                        Thank you so much to everyone who attended - we
                        hope you were able to offer up and listen to valuable perspectives!
                    </p>

                    <img src={GHCTapia22Graphic} alt="Attendees of the Grace Hopper and Tapia Reflection Event" />
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default GHCTapia22Recap;